import {defaultLegendOptions, defaultPieSeries} from "@/pages/dashboard/pages/datalab/ReportAnalysis/_config/config";
import {trim} from "@/utils/utils";
import {DEEP_COLORS, LIGHT_COLORS} from "@/pages/dashboard/_config/constant";

/**
 * 获取折线图或柱状图legend配置
 * @param chartData
 * @param isContrast
 */
export function getLegend(chartData, isContrast) {
  const colors = isContrast ? LIGHT_COLORS : DEEP_COLORS;
  const data = chartData?.map?.((data, index) => {
    return {
      name: data?.dimension_name,
      itemStyle: {
        color: colors[index % 10],
      }
  }
  })

  return {
    ...defaultLegendOptions,
    data,
    bottom: isContrast ? 2 : 26,
    // formatter: isContrast ? trim : undefined,
    left: 100,
    width: "90%"
  }

}
// 获取series数据
/**
 * 获取折线图或者柱状图的series配置
 * @param chartData
 * @param chartType
 * @param metricName
 * @param isContrast
 */
export function getSeriesData(chartData, chartType, metricName, isContrast) {
  const colors = isContrast ? LIGHT_COLORS : DEEP_COLORS;
  return chartData?.map?.((data, index) => {
    const {dimension_name, metrics} = data || {};
    // const name = isContrast? `${dimension_name} ` : dimension_name;
    const seriesData = metrics?.map?.((item) => item?.axisValues?.[metricName]?.value);
    const stack = chartType === 'bar' ? (isContrast ? "one" : "two") : undefined;
    return {
      name: dimension_name,
      type: chartType,
      data: seriesData,
      color: colors[index % 10],
      stack,
      z: index === 0 ? 1 : 0,
      lineStyle: {
        type: isContrast ? "dotted" : 'solid'
      }
    }
  }) || []
}

/**
 * 获取x轴配置项data数据
 * @param firstChartData
 */
export function getXAxisData(firstChartData) {
  return firstChartData?.[0]?.metrics?.map?.(item => item?.axisPoint) || [];
}

export function getPieSeries(pieData, metricName, isContrast) {
  const pieSeries = [];
  const pieLegendData = [];
  const colors = isContrast ? LIGHT_COLORS : DEEP_COLORS;
  metricName ? pieData?.[metricName]?.forEach?.((data, index) => {
    // const name = isContrast ? `${data?.dimension_name} ` : data?.dimension_name;
    pieLegendData.push({
      name: data?.dimension_name,
      itemStyle: {
        color: colors[index % 10],
      }
    });
    pieSeries.push({
      name: data?.dimension_name,
      ...data?.value,
      itemStyle: {
        color: colors[index % 10],
      }
    });
  }) : [];
  const series = {
    ...defaultPieSeries,
    data: pieSeries,
    name: metricName,
  };
  series.center = [isContrast ? "75%" : "25%" , '40%']
  series.label.formatter = (item) => {
    const { name, data } = item
    return `{name|${name}}：{per|${data?.percent}}\n{hr|}\n{a|}`
  }
    return {
    legend: {
      ...defaultLegendOptions,
      data: pieLegendData,
      bottom: isContrast ? 2 : 26,
      formatter: isContrast ? trim : undefined,
      left: 100,
      width: "90%"
    },
    series,
  }
}

/**
 * arr1排序后, arr2按照arr1的排序顺序进行排序.
 * @param arr1
 * @param arr2
 */
export function sortChart(arr1=[], arr2=[]) {
  for (let i = 0; i < arr1.length; i++) {
    for (let j = i+1; j < arr1.length; j++) {
      const data1 = isNaN(arr1[i]?.data) ? -1 : Number(arr1[i]?.data) ;
      const data2 = isNaN(arr1[j]?.data) ? -1 : Number(arr1[j]?.data) ;
      if (data1 - data2 < 0) {
        swap(arr1, i, j);
        swap(arr2, i, j);
      }
    }
  }
  return [arr1, arr2];
}

function swap(arr, i, j) {
  // 两个arr的长度不一致,可能会导致取值为undefined;
  if (!(arr[i] || arr[j])) return;
  const temp = arr[i];
  arr[i] = arr[j];
  arr[j] = temp;
}
